import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.9367 18.7421L3.5 12.3054L5.47879 10.3266L9.9367 14.7845L19.5212 5.20001L21.5 7.1788L9.9367 18.7421Z" }));
export default SvgCheck;
